import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useTranslation } from "react-i18next";

import type { Flashcard } from "src/helpers/flashcards/ankiImport";

const PREVIEW_ROWS = 3;

// Fiszki trzymamy jako HTML — w podglądzie wystarczy sam tekst.
// Koniec akapitu/linii → spacja, inaczej textContent skleja "zdanie.Kolejne".
const toPlainText = (html: string) =>
	new DOMParser().parseFromString(
		html.replace(/<\/(p|div|li|blockquote)>|<br\s*\/?>/gi, " "),
		"text/html",
	).body.textContent ?? "";

interface ImportPreviewProps {
	flashcards: Flashcard[];
	frontSource: string;
	backSource: string;
}

export const ImportPreview = ({
	flashcards,
	frontSource,
	backSource,
}: ImportPreviewProps) => {
	const { t } = useTranslation();
	const rest = flashcards.length - PREVIEW_ROWS;

	return (
		<div className="border-medium-grey border-radius-12 of-hidden">
			<Table size="small" className="table-compact">
				<TableHead>
					<TableRow>
						<TableCell>
							{t("csvImport.frontShort", "Przód")}{" "}
							<span className="chip chip--primary">{frontSource}</span>
						</TableCell>
						<TableCell>
							{t("csvImport.backShort", "Tył")}{" "}
							<span className="chip chip--primary">{backSource}</span>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{flashcards.slice(0, PREVIEW_ROWS).map((flashcard, i) => (
						<TableRow key={i}>
							<TableCell className="font-semibold">
								<span className="text-ellipsis-3 word-break-normal">
									{toPlainText(flashcard.front)}
								</span>
							</TableCell>
							<TableCell className="text-dark-grey">
								<span className="text-ellipsis-3 word-break-normal">
									{toPlainText(flashcard.back)}
								</span>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
			{rest > 0 && (
				<div className="size-14-light text-grey px-12 py-8 bg-grey overwritten-bg-to-fill2 overwritten-color-to-black100-important border-top-1">
					{t("flashcardsImport.preview.more", {
						count: rest,
						defaultValue: "… i {{count}} kolejnych wierszy",
					})}
				</div>
			)}
		</div>
	);
};
